import Label from 'LuxKit/Label'
import { useOfferBestPrice } from 'hooks/Offers/useOfferBestPrice'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import useOfferMetaData from 'hooks/Offers/useOfferMetaData'
import { OFFER_BOOKINGS_THRESHOLD } from 'constants/offer'
import BookingsCountLabel from 'components/Common/Labels/BookingsCountLabel'
import { getShouldUseSearchPrices } from 'lib/search/searchUtils'

const URGENCY_TAG_THRESHOLD = 5

interface Props {
  offer: App.Offer | App.OfferSummary
  filters?: App.OfferListFilters
}

function OfferTilePricingUrgencyTags(props: Props) {
  const {
    offer,
    filters,
  } = props

  const numRoomsPackage = useOfferBestPrice(offer, filters, { disabled: getShouldUseSearchPrices(filters) })
  const offerMetaData = useOfferMetaData(offer.id, filters)

  const showBookedTodayUrgencyTag = offer.stats.booked >= OFFER_BOOKINGS_THRESHOLD

  const availableRooms = numRoomsPackage?.availableRooms ?? offerMetaData?.availableRooms
  const showLowRoomsUrgencyTag = !showBookedTodayUrgencyTag &&
    !!availableRooms &&
    availableRooms !== 0 &&
    availableRooms <= URGENCY_TAG_THRESHOLD &&
    !!filters?.checkIn

  return <>
    <BookingsCountLabel bookings={offer.stats.booked} threshold="offer" />
    {showLowRoomsUrgencyTag && <Label variant="urgency" kind="plain">
      <FormattedMessage
        id="YWK+9mp9Bm"
        defaultMessage="Only {availableRooms, plural, one {# room} other {# rooms}} left at this price!"
        description="Urgency tag showing limited rooms remaining at the current price"
        values={{ availableRooms }}
      />
    </Label>}
  </>
}

export default React.memo(OfferTilePricingUrgencyTags)
